// You can customize the template with the help of this file
export const name = 'کتاب آوران'
export const logo = 'ketab.png'
//Template config options
const themeConfig = {
    app: {
        appName: name,
        appLogoImage: require(`@src/assets/images/logo/${logo}`).default
    },
    layout: {
        isRTL: true,
        skin: 'dark', // light, dark, bordered, semi-dark
        routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
        type: 'vertical', // vertical, horizontal
        contentWidth: 'full', // full, boxed
        menu: {
            isHidden: false,
            isCollapsed: false
        },
        navbar: {
            // ? For horizontal menu, navbar type will work for navMenu type
            type: 'floating', // static , sticky , floating, hidden
            backgroundColor: 'white' // BS color options [primary, success, etc]
        },
        footer: {
            type: 'static' // static, sticky, hidden
        },
        customizer: false,
        scrollTop: true // Enable scroll to top button
    }
}

export default themeConfig
